export {
  fetchOddsGridApiData,
  fetchOddsGridData,
  fetchOddsGridVerticalData,
  isOddsGridApiErrorResponse,
} from '@cx-modules/odds-grid-api-service';

export type {
  OddsGridApiErrorResponse,
  OddsGridApiRequestParams,
  OddsGridApiResponseData,
  OddsGridRequestParams,
  OddsGridResponseData,
  OddsGridVerticalRequestParams,
  OddsGridVerticalResponseData,
} from '@cx-modules/odds-grid-api-service';

export const getOddsGridCacheKey = ({
  countryCode,
  marketId,
  overrideBookies,
  repub,
  subdivision,
}: {
  countryCode: string;
  marketId: number;
  overrideBookies?: string[];
  repub: string;
  subdivision: string;
}) => {
  // Normalise empty/undefined to the same key so `[]` and `undefined` don't fragment the
  // cache (a mismatch here causes a cache miss → an unhandled live API call). Copy before
  // sorting to avoid mutating the caller's array.
  const overrideBookiesKey = overrideBookies?.length ? [...overrideBookies].sort().join(',') : null;

  return ['odds-grid', repub, countryCode, subdivision, marketId, overrideBookiesKey];
};
